<template>
  <view class="item" v-for="(item,k) in subList" :key="k" :class="direction"
        @animationiteration="k === 0 && onAnimationIteration()">
    <slot name="item" :item="item"/>
  </view>
</template>

<script setup lang="ts">
import {computed, reactive} from "vue";

interface ListProps<T = unknown> {
  list: T[],
  direction: 'left' | 'top',
  sectionLength: number,
  interval: string,
}

const props = defineProps<ListProps>();
const info = reactive({idx: 0})
const originList = computed(() => repeatArray(props.list, props.sectionLength))
const subList = computed(() => {
  if (props.list.length == 0) return []
  return [...originList.value, ...originList.value].slice(info.idx, info.idx + props.sectionLength * 2)
})

function repeatArray<T>(arr: T[], targetLength: number): T[] {
  if (arr.length === 0) return [];

  const result: T[] = [...arr];

  while (result.length < targetLength) {
    // 每次添加整个数组，但不超过目标长度
    const remaining = targetLength - result.length;
    result.push(...arr.slice(0, remaining));
  }

  return result;
}

const onAnimationIteration = () => info.idx = (info.idx + props.sectionLength) % originList.value.length

</script>

<style scoped lang="sass">
.left
  display: block
  animation: scrollX v-bind('props.interval') ease-in-out infinite

.top
  display: block
  animation: scrollY v-bind('props.interval') ease-in-out infinite


@keyframes scrollY
  0%
    transform: translateY(0)
  10%
    transform: translateY(-100%)
  100%
    transform: translateY(-100%)

@keyframes scrollX
  0%
    transform: translateX(0)
  10%
    transform: translateX(-100%)
  100%
    transform: translateX(-100%)
</style>